import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountService } from './account.service';

@NgModule({
  imports: [CommonModule],
  providers: [AccountService],
})
export class AccountServiceModule {}
